import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Boxes } from "lucide-react";

interface SupplyAvailabilityProps {
  byproduct: string;
  volume: string;
  driedPastaOutput: string;
  suppliers: string[];
}

export default function SupplyAvailabilityTable({
  byproduct,
  volume,
  driedPastaOutput,
  suppliers,
}: SupplyAvailabilityProps) {
  return (
    <Card className="shadow-lg border border-slate-200 rounded-xl overflow-hidden h-full flex flex-col">
      <CardHeader className="pb-3 pt-5 px-6">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <Boxes size={20} className="text-indigo-600" />
          Supply Availability
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-grow">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-slate-300 bg-slate-100">
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">By-product</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">Volume, ton annually</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">Product Volume</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-medium text-slate-500">By-product Suppliers</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="border-t border-slate-200 hover:bg-slate-50 transition-colors">
              <TableCell className="p-4 align-middle text-base text-slate-600">{byproduct}</TableCell>
              <TableCell className="p-4 align-middle text-base text-slate-600">{volume}</TableCell>
              <TableCell className="p-4 align-middle text-base text-slate-600">{driedPastaOutput}</TableCell>
              <TableCell className="p-4 align-middle text-base text-slate-600">{suppliers.join(", ")}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
